import type { UserPreferences } from "./types.js";
import { getCookie } from "../internal/cookieUtils.js";

let userPreferences: UserPreferences;
export const getUserPreferences = () => {
  if (!userPreferences) {
    userPreferences = {
      colorTheme: getCookie("awsc-color-theme") || "light",
      locale: document.documentElement.lang,
    };
  }
  // wrap in a promise to set async contract.
  return Promise.resolve(userPreferences);
};
